/* unplugin-vue-components disabled */import script from "./calling.vue?vue&type=script&setup=true&lang=js"
export * from "./calling.vue?vue&type=script&setup=true&lang=js"

import "./calling.vue?vue&type=style&index=0&id=3c4ea2b7&lang=scss"

const __exports__ = script;

export default __exports__